import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface NoticeProps {
  tone?: "info" | "warning" | "danger" | "muted";
  title?: ReactNode;
  children: ReactNode;
  className?: string;
}

const toneClasses: Record<NonNullable<NoticeProps["tone"]>, string> = {
  info: "border-blue-200 bg-blue-50 text-blue-700",
  warning:
    "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-400",
  danger: "border-destructive/20 bg-destructive/10 text-destructive",
  muted: "border-border/70 bg-muted/20 text-foreground/72",
};

export function Notice({ tone = "muted", title, children, className }: NoticeProps) {
  return (
    <div className={cn("rounded-lg border px-3 py-2 text-sm", toneClasses[tone], className)}>
      {title ? <span className="font-medium">{title}: </span> : null}
      {children}
    </div>
  );
}
